import * as React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/spinner/Spinner';
import MentionCardModalAssetInstagram
  from 'components/mention-card/mention-card-modal-asset/channels/instagram/MentionCardModalAssetInstagram';

import { fetchPost, resetPost } from '../../reducers/wrappedPostReducer';

import type { ContentListPostPayload, MentionCardModalItem } from 'types';
import type { WrappedPostLoadingState } from 'modules/lists-content/components/wrapped-post/WrappedPost.type';
import type { ConsentReducerConsentsMap } from 'redux-store/types/ConsentReducer.type';

import 'modules/lists-content/components/wrapped-post/wrapped-post.scss';

type OwnProps = {
  currentPosition: number,
  organizationId: number,
  postId: string | undefined | null
};

type StateProps = {
  loadingState: WrappedPostLoadingState,
  postData: ContentListPostPayload,
  userChannelConsents: ConsentReducerConsentsMap
};

type DispatchProps = {
  dispatchFetchPost: (b: number, a: string) => Promise<void>,
  dispatchPostReset: () => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const WrappedPost = ({
  currentPosition,
  organizationId,
  postId,
  loadingState,
  postData,
  userChannelConsents,
  dispatchFetchPost,
  dispatchPostReset
}: Props): JSX.Element => {
  React.useEffect(() => {
    if (postId) {
      dispatchFetchPost(organizationId, postId);
    }

    return () => {
      dispatchPostReset();
    };
  }, [postId]);

  const mappedPostDataWithImage: MentionCardModalItem = {
    ...postData,
    profileId: postData.influencerData?.id,
    profileImageUrl: postData.influencerData?.profileImage,
    profileName: postData.influencerData?.name,
    profileStatus: postData.influencerData?.profileStatus,
    assetUrl: postData.assetUrl
  };

  return (
    <div className="wrapped-post">
      {loadingState === 'loading' && (
        <Spinner
          position="cover"
          size="small"
          color="light"
        />
      )}
      {loadingState === 'loaded' && (
        <MentionCardModalAssetInstagram
          userChannelConsents={userChannelConsents}
          currentPosition={currentPosition}
          selectedItem={mappedPostDataWithImage}
        />
      )}
    </div>
  );
};

function mapStateToProps({ wrappedPost, consentReducer }): StateProps {
  return {
    loadingState: wrappedPost.loadingState,
    postData: wrappedPost.postData,
    userChannelConsents: consentReducer.consents
  };
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    dispatchFetchPost: (orgId: number, postId: string) => dispatch(fetchPost(orgId, postId)),
    dispatchPostReset: () => dispatch(resetPost())
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(WrappedPost);
